function SeasunDcLogger() {
  // console.log('SeasunDcLogger start');
}

// 环境相关功能，默认为web环境功能实现
//发送get请求
SeasunDcLogger.getRequest = function(url) {
  // console.log(' getRequest = ' + url);
  if (!window['wx']) {
    try {
      var xmlhttp = null;
      try {
        xmlhttp = new XMLHttpRequest();
      } catch (e2) {
        try {
          xmlhttp = window.ActiveXobject('Msxml12.XMLHTTP');
        } catch (e3) {
          try {
            xmlhttp = window.ActiveXobject('Microsoft.XMLHTTP');
          } catch (e4) {
            if (console) {
              console.log('SeasunDcLogger.getRequest() Error');
            }
          }
        }
      }

      if (xmlhttp) {
        try {
          xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4 && xmlhttp.status < 400) {
              //
              if (console) {
                // console.log('SeasunDcLogger.getRequest() OK');
              }
            }
          };

          xmlhttp.open('GET', url, true);
          xmlhttp.send(null);
          // console.log('SeasunDcLogger.getRequest() xmlhttp send OK');
        } catch (e5) {
          if (console) {
            // console.log('SeasunDcLogger.getRequest() Error');
          }
        }
      }
    } catch (e1) {
      //console.log("SeasunDcLogger.getRequest() catch");
      var script = document.createElement('script');
      script.src = url;
      document.body.insertBefore(script, document.body.firstChild);
      //console.log("SeasunDcLogger.getRequest() script send OK");
    }
  } else {
    // console.log('getRequest url = ' + url);
    window['wx'].request({
      url: url, // 仅为示例，并非真实的接口地址

      method: 'GET',
      header: {
        'content-type': 'application/x-www-form-urlencoded' // 默认值
      },
      success(res) {
        // console.log('SeasunDcLogger.getRequest() script send OK = ' + res.data);
      },
      fail(res) {
        throw new Error('SeasunDcLogger.getRequest() script send fail');
      }
    });
  }
};

//应答的结果处理
SeasunDcLogger.handleResponse = function(response) {
  console.log(response);
};

//每格一段时间（invterval）执行指定方法（fun）一次，返回一个值供customClearInterval(threadId)方法停止该操作
SeasunDcLogger.customSetInterval = function(fun, interval) {
  return setInterval(fun, interval);
};

//把值保存到本地存储
SeasunDcLogger.setLocalStorage = function(key, value) {
  localStorage.setItem(key, value);
};

//从本次存储里取出指定的值
SeasunDcLogger.getLocalStorage = function(key) {
  return localStorage.getItem(key);
};

//发生错误是记录日志
SeasunDcLogger.onError = function(error) {
  try {
    if (console) console.log(error);
  } catch (error) {
    // do nothing
  }
};

// 环境无关部分
SeasunDcLogger.heartbeatThreadId = null;
SeasunDcLogger._dcLoggerConfig = null;
SeasunDcLogger._dcLog = [];
SeasunDcLogger.heartbeat = null;
SeasunDcLogger.deviceId = null;

//配置数据上报SDK
SeasunDcLogger.config = function(config) {
  try {
    if (!config) {
      // eslint-disable-next-line no-throw-literal
      throw 'config is null.';
    }
    SeasunDcLogger._AgentInfo._init();
    SeasunDcLogger._dcLoggerConfig = config;

    if (config.getRequest) {
      SeasunDcLogger.getRequest = config.getRequest;
    }
    if (config.handleResponse) {
      SeasunDcLogger.handleResponse = config.handleResponse;
    }
    if (config.customSetInterval) {
      SeasunDcLogger.customSetInterval = config.customSetInterval;
    }
    if (config.setLocalStorage) {
      SeasunDcLogger.setLocalStorage = config.setLocalStorage;
    }
    if (config.getLocalStorage) {
      SeasunDcLogger.getLocalStorage = config.getLocalStorage;
    }
    if (config.onError) {
      SeasunDcLogger.onError = config.onError;
    }
    //初始化之后才可以
    SeasunDcLogger.deviceId = SeasunDcLogger.getLocalStorage('SeasunDcLogger.deviceId');
    // console.log(' SeasunDcLogger.deviceId = ' + SeasunDcLogger.deviceId);
    //console.log("SeasunDcLogger onlineSessionId = " + SeasunDcLogger._guid());
    if (!SeasunDcLogger.deviceId) {
      SeasunDcLogger.deviceId = SeasunDcLogger._guid();
      SeasunDcLogger.setLocalStorage('SeasunDcLogger.deviceId', SeasunDcLogger.deviceId);
    }
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.push = function(log) {
  try {
    //console.log("SeasunDcLogger._dcLog = " + SeasunDcLogger._dcLog);
    if (SeasunDcLogger._dcLog === undefined) {
      return;
    }
    // console.log('SeasunDcLogger.push log.msgType = ' + log.msgType);
    SeasunDcLogger._dcLog.push(log);
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.consume = function() {
  try {
    if (SeasunDcLogger._dcLog === undefined || SeasunDcLogger._dcLog.length === 0) {
      return;
    }

    if (!(SeasunDcLogger._dcLoggerConfig && SeasunDcLogger._dcLoggerConfig.appId)) {
      return;
    }

    var toSendMessages = [];
    var toSendBase64Message = null;
    var log = SeasunDcLogger._dcLog.shift();
    while (log !== undefined) {
      // 更新角色信息
      // console.log(' SeasunDcLogger.sendHeartbeat() 0 log.msgType=  ' + log.msgType);
      SeasunDcLogger.updateRoleInfo(log);

      if (log.msgType && 'role.login' === log.msgType) {
        // console.log(' SeasunDcLogger.sendHeartbeat() 1 ');
        SeasunDcLogger.sendHeartbeat();
      }
      if (log.msgType && 'role.logout' === log.msgType) {
        // console.log(' SeasunDcLogger.sendHeartbeat() 2 ');
        SeasunDcLogger.heartbeat = null;
      }

      var logMsg = SeasunDcLogger.buildMessage(log);
      toSendMessages.push(logMsg);
      toSendBase64Message = encodeURIComponent(JSON.stringify(toSendMessages, SeasunDcLogger._replacer));

      SeasunDcLogger.send(toSendBase64Message);
      toSendMessages = [];
      toSendBase64Message = null;

      log = SeasunDcLogger._dcLog.pop();
    }

    if (toSendBase64Message && toSendBase64Message.length > 0) {
      SeasunDcLogger.send(toSendBase64Message);
    }
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.updateRoleInfo = function(log) {
  // console.log('updateRoleInfo heartbeat log = ' + log);
  try {
    if (!log) {
      // console.log('updateRoleInfo heartbeat return ');
      return;
    }
    if (log.msgType && 'role.login' === log.msgType) {
      // console.log('updateRoleInfo heartbeat -------------1-------------- ');
      SeasunDcLogger.heartbeat = SeasunDcLogger._deepClone(log);
      // console.log('updateRoleInfo heartbeat --------------2------------- ');
      SeasunDcLogger.heartbeat.msgType = 'device.heartbeat';
      // console.log('updateRoleInfo heartbeat --------------3------------- ');
      SeasunDcLogger.heartbeat.onlineSessionId = SeasunDcLogger._guid();
      // console.log('SeasunDcLogger.heartbeat.onlineSessionId = ' + SeasunDcLogger.heartbeat.onlineSessionId);
    } else {
      if (!SeasunDcLogger.heartbeat) {
        return;
      }

      if (log.roleName) {
        SeasunDcLogger.heartbeat.roleName = log.roleName;
      }
      if (log.roleType) {
        SeasunDcLogger.heartbeat.roleType = log.roleType;
      }
      if (log.roleLevel) {
        SeasunDcLogger.heartbeat.roleLevel = log.roleLevel;
      }
      if (log.roleVipLevel) {
        SeasunDcLogger.heartbeat.roleVipLevel = log.roleVipLevel;
      }
      if (log.zone) {
        SeasunDcLogger.heartbeat.zone = log.zone;
      }
      if (log.zoneName) {
        SeasunDcLogger.heartbeat.zoneName = log.zoneName;
      }
      if (log.roleName) {
        SeasunDcLogger.heartbeat.roleName = log.roleName;
      }
      if (log.server) {
        SeasunDcLogger.heartbeat.server = log.server;
      }
      if (log.serverName) {
        SeasunDcLogger.heartbeat.serverName = log.serverName;
      }
      if (log.partyId) {
        SeasunDcLogger.heartbeat.partyId = log.partyId;
      }
      if (log.gender) {
        SeasunDcLogger.heartbeat.gender = log.gender;
      }
      if (log.battleScore) {
        SeasunDcLogger.heartbeat.battleScore = log.battleScore;
      }
    }
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.buildMessage = function(logInfo) {
  try {
    if (logInfo) {
      if (SeasunDcLogger._AgentInfo) {
        logInfo.os = SeasunDcLogger._AgentInfo.OSname;
        logInfo.browserName = SeasunDcLogger._AgentInfo.browserName;
        logInfo.browserVer = SeasunDcLogger._AgentInfo.browserVer;
      }
      logInfo.deviceScreen = '' + window.document.body.clientWidth + '*' + window.document.body.clientHeight;
      logInfo.msgId = SeasunDcLogger._guid();
      logInfo.msgVersion = '3.0.0';
      logInfo.dataSdkVersion = '2.0.0';
      logInfo.dataSdkLanguage = 'js';
      logInfo.datasource = 'client';
      logInfo.appId = SeasunDcLogger._dcLoggerConfig.appId;
      logInfo.appVersion = SeasunDcLogger._dcLoggerConfig.appVersion;
      logInfo.channel = SeasunDcLogger._dcLoggerConfig.channel;
      logInfo.commonAttributes = SeasunDcLogger._dcLoggerConfig.commonAttributes;
      logInfo.userAgent = window.navigator.userAgent;
      // console.log('logInfo.userAgent = ' + logInfo.userAgent);
      logInfo.deviceId = SeasunDcLogger.deviceId;

      logInfo.timestamp = new Date();
      logInfo.timestamp.toJSON = function() {
        return SeasunDcLogger._dateFtt('yyyy-MM-dd hh:mm:ss.S', logInfo.timestamp);
      };
    }
    return logInfo;
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.send = function(message) {
  try {
    if (!message) {
      return;
    }

    // default https, when http to http
    var defaultUrl = '//xgdata.xoyo.games:893/jspush';
    // if("https:" === window.location.protocol) {
    //     defaultUrl = "https:" + defaultUrl;
    // } else {
    //     defaultUrl = "http:" + defaultUrl;
    // }
    defaultUrl = 'https:' + defaultUrl;
    var url = defaultUrl;
    var inserUrl =
      url +
      '?appId=' +
      SeasunDcLogger._dcLoggerConfig.appId +
      '&data=' +
      message +
      '&df=js_batch&callback=SeasunDcLogger.handleResponse&time=' +
      Number(new Date());
    //console.log("getRequest:"+inserUrl);
    SeasunDcLogger.getRequest(inserUrl);
    //console.log("getRequest ok");
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.sendHeartbeat = function() {
  try {
    // console.log('SeasunDcLogger.heartbeat 1 SeasunDcLogger.heartbeat = ' + SeasunDcLogger.heartbeat);
    if (!SeasunDcLogger.heartbeat) {
      // console.log('SeasunDcLogger.heartbeat 2');
      return;
    }
    // console.log('SeasunDcLogger.heartbeat 3');
    if (SeasunDcLogger._dcLog === undefined) {
      // console.log('SeasunDcLogger.heartbeat 4');
      return;
    }
    // console.log('SeasunDcLogger.heartbeat');
    // console.log(SeasunDcLogger.heartbeat);
    SeasunDcLogger._dcLog.push(SeasunDcLogger.heartbeat);
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.start = function() {
  //console.log("SeasunDcLogger.start");
  try {
    // default 1 seconds
    var interval = 1000 * 1;
    if (SeasunDcLogger._dcLoggerConfig.interval) {
      interval = SeasunDcLogger._dcLoggerConfig.interval;
    }
    //console.log("SeasunDcLogger.start1");
    var connectInfo = {
      msgType: 'device.connect',
      currentUrl: window.location.href
    };
    SeasunDcLogger._dcLog.push(connectInfo);
    //console.log("SeasunDcLogger.start2");
    SeasunDcLogger.customSetInterval(SeasunDcLogger.consume, interval);
    //console.log("SeasunDcLogger.start3");
    SeasunDcLogger.customSetInterval(SeasunDcLogger.sendHeartbeat, 1000 * 60 * 5);
    // console.log("SeasunDcLogger.start4");
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

SeasunDcLogger.end = function() {
  try {
    SeasunDcLogger.consume();
  } catch (error) {
    SeasunDcLogger._onError(error);
  }
};

// 以下是业务无关方法
SeasunDcLogger._onError = function(error) {
  try {
    SeasunDcLogger.onError(error);
  } catch (err) {
    //do nothing
  }
};

SeasunDcLogger._dateFtt = function(fmt, date) {
  var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
};

SeasunDcLogger._isClass = function(o) {
  if (o === null) return 'Null';
  if (o === undefined) return 'Undefined';
  return Object.prototype.toString.call(o).slice(8, -1);
};

SeasunDcLogger._deepClone = function deepFunc(obj) {
  var result,
    oClass = SeasunDcLogger._isClass(obj);
  //确定result的类型
  if (oClass === 'Object') {
    result = {};
  } else if (oClass === 'Array') {
    result = [];
  } else {
    return obj;
  }
  for (var key in obj) {
    var copy = obj[key];
    if (SeasunDcLogger._isClass(copy) === 'Object') {
      result[key] = deepFunc(copy); //递归调用
    } else if (SeasunDcLogger._isClass(copy) === 'Array') {
      result[key] = deepFunc(copy);
    } else {
      result[key] = obj[key];
    }
  }
  return result;
};

SeasunDcLogger._replacer = function(key, value) {
  if (typeof value === 'string' && (value === '' || value === null)) {
    return undefined;
  }
  return value;
};

SeasunDcLogger._guid = function() {
  return SeasunDcLogger._s4n(3) + '-' + SeasunDcLogger._s4n(1) + '-' + SeasunDcLogger._s4n(1) + '-' + SeasunDcLogger._s4n(3);
};

SeasunDcLogger._s4n = function(n) {
  var result = '';
  for (var i = 0; i < n; i++) {
    result = result + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return result;
};

SeasunDcLogger._AgentInfo = {
  deviceType: '', // pc or mobile
  OSname: '', // windows, Android, linux and so on...
  browserName: '', //  chrome, safari, firefox, IE and so on...
  browserVer: '', //  browser version， important if in IE environment.
  adaptType: 0, // A type value, Adapt to the screen due to width
  _init: function() {
    try {
      SeasunDcLogger._AgentInfo.setDeviceAndOS();
      SeasunDcLogger._AgentInfo.setBrowser();
    } catch (err) {
      console.log(err);
    }
  },
  setDeviceAndOS: function() {
    var name = 'unknown';
    if (window['wx']) {
      var res = window['wx'].getSystemInfoSync();
      SeasunDcLogger._AgentInfo.OSname = res.system;
      SeasunDcLogger._AgentInfo.deviceType = 'mobile';
      return;
    }
    if (window.navigator.userAgent.indexOf('Android') !== -1) {
      name = 'Android';
    } else if (window.navigator.userAgent.indexOf('iPhone') !== -1) {
      name = 'iPhone';
    } else if (window.navigator.userAgent.indexOf('SymbianOS') !== -1) {
      name = 'SymbianOS';
    } else if (window.navigator.userAgent.indexOf('Windows Phone') !== -1) {
      name = 'Windows Phone';
    } else if (window.navigator.userAgent.indexOf('iPad') !== -1) {
      name = 'iPad';
    } else if (window.navigator.userAgent.indexOf('iPod') !== -1) {
      name = 'iPod';
    }
    if (name !== 'unknown') {
      SeasunDcLogger._AgentInfo.OSname = name;
      SeasunDcLogger._AgentInfo.deviceType = 'mobile';
      return;
    }
    if (window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1) {
      name = 'Windows 10';
    } else if (window.navigator.userAgent.indexOf('Windows NT 6.2') !== -1) {
      name = 'Windows 8';
    } else if (window.navigator.userAgent.indexOf('Windows NT 6.1') !== -1) {
      name = 'Windows 7';
    } else if (window.navigator.userAgent.indexOf('Windows NT 6.0') !== -1) {
      name = 'Windows Vista';
    } else if (window.navigator.userAgent.indexOf('Windows NT 5.1') !== -1) {
      name = 'Windows XP';
    } else if (window.navigator.userAgent.indexOf('Windows NT 5.0') !== -1) {
      name = 'Windows 2000';
    } else if (window.navigator.userAgent.indexOf('Mac') !== -1) {
      name = 'Mac/iOS';
    } else if (window.navigator.userAgent.indexOf('X11') !== -1) {
      name = 'UNIX';
    } else if (window.navigator.userAgent.indexOf('Linux') !== -1) {
      name = 'Linux';
    }
    SeasunDcLogger._AgentInfo.OSname = name;
    SeasunDcLogger._AgentInfo.deviceType = 'pc';
  },
  setBrowser: function() {
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
      // In Opera, the true version is after "Opera" or after "Version"
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) !== -1) fullVersion = nAgt.substring(verOffset + 8);
    } else if (nAgt.indexOf('Trident') !== -1) {
      // ( ver >= ie7) In MSIE, the true version is after "MSIE" in userAgent
      if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        fullVersion = nAgt.substring(verOffset + 5);
      } else {
        fullVersion = '11.0';
      }
      if (fullVersion === 5) {
        fullVersion = '11.0';
      }
      browserName = 'IE';
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
      // In Chrome, the true version is after "Chrome"
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
      // In Safari, the true version is after "Safari" or after "Version"
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) !== -1) fullVersion = nAgt.substring(verOffset + 8);
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
      // In Firefox, the true version is after "Firefox"
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
      // In most other browsers, "name/version" is at the end of userAgent
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    if ((ix = fullVersion.indexOf(';')) !== -1)
      // trim the fullVersion string at semicolon/space if present
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) !== -1) fullVersion = fullVersion.substring(0, ix);
    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    if (window['wx']) {
      var res = window['wx'].getSystemInfoSync();
      browserName = 'wx';
      fullVersion = res.version;
    }
    SeasunDcLogger._AgentInfo.browserName = browserName;
    SeasunDcLogger._AgentInfo.browserVer = fullVersion;
  },
  isMobile: function() {
    if (SeasunDcLogger._AgentInfo.deviceType === 'mobile') {
      return true;
    }
    return false;
  },
  setAdaptType: function() {
    // A type value, Adapt to the screen due to width. For convenient
    if (window.screen.width <= 374) {
      SeasunDcLogger._AgentInfo.adaptType = 0;
    } else if (window.screen.width <= 413) {
      SeasunDcLogger._AgentInfo.adaptType = 1;
    } else {
      SeasunDcLogger._AgentInfo.adaptType = 2;
    }
  }
};

//window.SeasunDcLogger = SeasunDcLogger;
export { SeasunDcLogger };
